module.exports = __webpack_public_path__ + "static/media/logo-beasiswa_jakarta.745f0026.png";